import { Controller } from "@hotwired/stimulus"

// Step 1 of the trial wizard: the subdomain follows the company name until
// the visitor edits it by hand.
export default class extends Controller {
  static targets = ["name", "subdomain"]

  connect() {
    this.manual = this.subdomainTarget.value.trim() !== "" &&
      this.subdomainTarget.value.trim() !== this.slug(this.nameTarget.value)
  }

  fromName() {
    if (this.manual) return
    this.subdomainTarget.value = this.slug(this.nameTarget.value)
  }

  touched() {
    this.manual = this.subdomainTarget.value.trim() !== ""
  }

  slug(text) {
    return text.toString().toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40)
  }
}
